import Login from '../components/presentations/login'

const LoginContainer = (props) => {
	return <Login {...props} />
}

export default LoginContainer
